import AdminLayout from '@/components/admin/AdminLayout';

export default function Agents() {
  return (
    <AdminLayout>
      <div className="eyebrow">AI Agents · Phase 2</div>
      <h1 className="h-title">Marketing & Outreach Hub</h1>
      <p className="lead" style={{ marginBottom: 32 }}>
        REACH, VOICE, OUTREACH, MARKET — four Claude-powered agents share brand voice and
        inventory context. Comes online in Phase 2.
      </p>
      <div className="empty-state" style={{ background: 'var(--bg-1)', border: '1px dashed var(--line-2)', padding: 60 }}>
        <div style={{ fontFamily: 'var(--display)', fontSize: 28, color: 'var(--text-dim)' }}>Phase 2 placeholder</div>
        <p>Agent definitions and approval workflow ship after Phase 1 closes.</p>
      </div>
    </AdminLayout>
  );
}
